module.exports = __webpack_public_path__ + "img/discover.38c9a5d9.jpg";